/* import __COLOCATED_TEMPLATE__ from './warm-transfer-team-calling.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';
import type AdminSummary from 'embercom/objects/inbox/admin-summary';

interface Signature {
  Args: {
    admin: AdminSummary;
    startedAt?: number;
    timeoutSeconds?: number;
  };
  Element: HTMLDivElement;
}

const WarmTransferTeamCalling = templateOnlyComponent<Signature>();
export default WarmTransferTeamCalling;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::WarmTransferTeamCalling': typeof WarmTransferTeamCalling;
    'inbox2/calling/warm-transfer-team-calling': typeof WarmTransferTeamCalling;
  }
}
